import { bunja } from 'bunja';
import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';

import { deleteUserFollowApi, postUserFollowApi } from '@flipster/apis/v1/user';

import { UserFollowQueryKey, UserProfileQueryKey } from '../../profile-page/bunja';

export const followBunja = bunja(() => {
  const postUserFollowMutationAtom = atomWithMutation((get) => ({
    mutationKey: ['postUserFollowApi'],
    mutationFn: (id: string) => postUserFollowApi(id),
    onSettled: async () => {
      const queryClient = get(queryClientAtom);
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: UserFollowQueryKey }),
        queryClient.invalidateQueries({ queryKey: UserProfileQueryKey }),
      ]);
    },
  }));
  const deleteUserFollowMutationAtom = atomWithMutation((get) => ({
    mutationKey: ['deleteUserFollowApi'],
    mutationFn: (id: string) => deleteUserFollowApi(id),
    onSettled: async () => {
      const queryClient = get(queryClientAtom);
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: UserFollowQueryKey }),
        queryClient.invalidateQueries({ queryKey: UserProfileQueryKey }),
      ]);
    },
  }));
  return { postUserFollowMutationAtom, deleteUserFollowMutationAtom };
});
